import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

function isModifierClick(event: React.MouseEvent) {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick
    || event.altKey
    || event.ctrlKey
    || event.metaKey
    || event.shiftKey,
  );
}

export default function Pagination({ additionalData, pagination }: componentTypes.PaginationProps) {
  const {
    pages,
    currentRefinement,
    isFirstPage,
    isLastPage,
    createURL,
    refine,
  } = pagination;

  const { search } = additionalData;

  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;

  if (pages.length < 2) {
    return null;
  }

  return (
    <div className="w-full mx-auto max-w-7xl mt-9 lg:mt-18">
      <nav aria-label="Pagination" className="box-border flex items-center justify-evenly pt-8 w-full">
        <a
          href={createURL(previousPageIndex)}
          aria-disabled={isFirstPage}
          onClick={(event) => {
            if (isModifierClick(event)) {
              return;
            }
            event.preventDefault();
            refine(previousPageIndex);
          }}
          className={`font-primary font-semibold not-italic no-underline overflow-ellipsis overflow-hidden relative shrink-0 text-sm/none text-center whitespace-nowrap px-4 py-2 rounded-none transition duration-200 flex items-center hover:underline hover:decoration-current ${isFirstPage ? 'text-gray-400 opacity-50 pointer-events-none' : 'text-brown-500 theme-contrast:text-gray-950'}`}
        >
          {Craft.t(search, 'Previous')}
        </a>
        <div className="gap-4 items-center justify-start hidden md:flex">
          {pages.map((page) => {
            const isActive = page === currentRefinement;
            const baseBtn = 'font-primary font-semibold not-italic no-underline overflow-ellipsis overflow-hidden relative shrink-0 text-center whitespace-nowrap flex items-center justify-center rounded-none transition duration-200';
            const activeExtras = 'bg-brown-500 text-white text-lg/none w-12.5 h-12.5 pointer-events-none';
            const inactiveExtras = 'text-brown-500 text-sm/none w-10.5 h-10.5 border border-brown-500 border-solid hover:bg-brown-500 hover:text-white';

            return (
              <a
                key={page}
                href={createURL(page)}
                onClick={(event) => {
                  if (isModifierClick(event)) {
                    return;
                  }
                  event.preventDefault();
                  refine(page);
                }}
                aria-current={isActive ? 'page' : undefined}
                className={`btn rounded-none p-0 items-center ${isActive ? 'btn-secondary w-12.5 h-12.5' : 'btn-outline-secondary w-10.5 h-10.5'}`}
              >
                {page + 1}
              </a>
            );
          })}
        </div>
        <a
          href={createURL(nextPageIndex)}
          aria-disabled={isLastPage}
          onClick={(event) => {
            if (isModifierClick(event)) {
              return;
            }
            event.preventDefault();
            refine(nextPageIndex);
          }}
          className={`font-primary font-semibold not-italic no-underline overflow-ellipsis overflow-hidden relative shrink-0 text-brown-500 text-sm/none text-center whitespace-nowrap px-4 py-2 rounded-none transition duration-200 flex items-center hover:underline hover:decoration-current ${isLastPage ? 'text-gray-400 opacity-50 pointer-events-none' : 'text-brown-500 theme-contrast:text-gray-950'}`}
        >
          {Craft.t(search, 'Next')}
        </a>
      </nav>
    </div>
  );
}